<div class="container">
  <div class="row">
    <div class="col-9">
      <mat-form-field class="compact-input" appearance="fill">
        <input type="text" matInput [formControl]="filterControl" placeholder="Filter">
      </mat-form-field>
    </div>
    <div class="col-3">
      <div class="row">
        <div class="col-6">
          <span>
            <button mat-flat-button (click)="changeView(DueDiligenceView.ALL)" class="sort-button" [ngClass]="{'sort-button--selected': view===DueDiligenceView.ALL}">All</button>
            |
            <button mat-flat-button (click)="changeView(DueDiligenceView.USER)" class="sort-button" [ngClass]="{'sort-button--selected': view===DueDiligenceView.USER}">Yours</button>
          </span>
        </div>
        <div class="col-6">
          <mat-form-field class="compact-input" appearance="fill">
            <mat-select [formControl]="sortCategoryControl">
              @for (category of sortCategories; track category) {
                <mat-option [value]="category">{{category}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  @if (!(ddService.loading$ | async)) {
    <div>
      @for (deal of ddService.deals$ | async; track deal) {
        <due-diligence-item [item]="deal" [checklists]="(ddService.checklistSections$ | async) ?? []"></due-diligence-item>
      }
    </div>
  }
</div>
